import { primaryButtonClass } from '@/components/common/formStyles'

interface WizardNavProps {
  onPrev?: () => void
  onNext?: () => void
  onSkip?: () => void
  onFinish?: () => void
  prevDisabled?: boolean
  nextDisabled?: boolean
  nextLabel?: string
  finishLabel?: string
  showSkip?: boolean
  isLast?: boolean
  /** Wenn true, wird der Next/Finish-Button ausgeblendet (z.B. weil der Step
   *  seinen eigenen Aktivierungs-Button besitzt). */
  hideNext?: boolean
}

const secondaryButtonClass =
  'border border-hairline px-4 py-2 font-mono text-xs text-muted transition-colors hover:text-bernstein disabled:opacity-40 disabled:hover:text-muted'

export function WizardNav({
  onPrev,
  onNext,
  onSkip,
  onFinish,
  prevDisabled,
  nextDisabled,
  nextLabel = 'Weiter',
  finishLabel = 'Abschließen',
  showSkip = false,
  isLast = false,
  hideNext = false,
}: WizardNavProps) {
  return (
    <div className="hairline-t mt-8 flex flex-col-reverse gap-3 pt-5 md:flex-row md:items-center md:justify-between md:gap-0">
      <button
        type="button"
        onClick={onPrev}
        disabled={prevDisabled}
        className={secondaryButtonClass}
      >
        ← Zurück
      </button>

      <div className="flex flex-wrap items-center justify-end gap-3">
        {showSkip && (
          <button type="button" onClick={onSkip} className={secondaryButtonClass}>
            Überspringen
          </button>
        )}
        {!hideNext && (
          <button
            type="button"
            onClick={isLast ? onFinish : onNext}
            disabled={nextDisabled}
            className={primaryButtonClass}
          >
            {isLast ? finishLabel : nextLabel} →
          </button>
        )}
      </div>
    </div>
  )
}
